import { render, staticRenderFns } from "./spacer.vue?vue&type=template&id=6375f9be&scoped=true&lang=pug"
import script from "./spacer.vue?vue&type=script&lang=coffee"
export * from "./spacer.vue?vue&type=script&lang=coffee"
import style0 from "./spacer.vue?vue&type=style&index=0&id=6375f9be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6375f9be",
  null
  
)

export default component.exports